import React, {Component} from 'react';
import {Modal,Button} from 'antd';
import Form from "./Form2";
import HttpUtils from "../../../utils/HttpUtils";

export default class AddAndBind extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            content: [
                {
                    name: '名字',
                    type: 'input',
                    dataIndex: 'name',
                    labelCol: 8,
                    required: true,
                    wrapperCol: 14,
                    message: '请填写名字'
                },
                {
                    name: '性别',
                    type: 'select',
                    dataIndex: 'gender',
                    labelCol: 8,
                    required: true,
                    wrapperCol: 14,
                    message: '请选择',
                    option: [
                        {id: 'M', name: '男'},
                        {id: 'F', name: '女'}
                    ]
                },
                {
                    name: '所属部门',
                    type: 'select',
                    dataIndex: 'dept_id',
                    labelCol: 8,
                    required: true,
                    wrapperCol: 14,
                    message: '请选择',
                    option: []
                },
                {
                    name: '审核结果',
                    type: 'select',
                    dataIndex: 'status',
                    required: true,
                    labelCol: 8,
                    wrapperCol: 14,
                    message: '请选择',
                    option: [
                        {id: 2, name: '通过'},
                        {id: 3, name: '拒绝'}
                    ]
                },
                {
                    name: '拒绝原因',
                    type: 'textarea',
                    dataIndex: 'reason',
                    placeholder: '拒绝必填',
                    labelCol: 8,
                    wrapperCol: 16,
                    message: '请填写拒绝原因'
                },
            ]
        };
    }

    componentDidMount() {
    }



    getList() {
        HttpUtils.postForm('/api/dept/list', {}).then(res => {
            if (res.status === 10000) {
                this.setState({
                    content:[
                        {
                            name: '名字',
                            type: 'input',
                            dataIndex: 'name',
                            labelCol: 8,
                            required: true,
                            wrapperCol: 14,
                            message: '请填写名字'
                        },
                        {
                            name: '性别',
                            type: 'select',
                            dataIndex: 'gender',
                            labelCol: 8,
                            required: true,
                            wrapperCol: 14,
                            message: '请选择',
                            option: [
                                {id: 'M', name: '男'},
                                {id: 'F', name: '女'}
                            ]
                        },
                        {
                            name: '所属部门',
                            type: 'select',
                            dataIndex: 'dept_id',
                            labelCol: 8,
                            required: true,
                            tip:'此部门和人脸识别权限挂钩，请认真核实',
                            wrapperCol: 14,
                            message: '请选择',
                            option: res.data.length > 0  ?   res.data.filter(item=>{return  item.status === true}).map(item=>{
                                return {
                                    id:item.id,
                                    name:item.name
                                }
                            }) : []
                        },
                        {
                            name: '审核结果',
                            type: 'select',
                            dataIndex: 'status',
                            required: true,
                            labelCol: 8,
                            wrapperCol: 14,
                            message: '请选择',
                            option: [
                                {id: 2, name: '通过'},
                                {id: 3, name: '拒绝'}
                            ]
                        },
                        {
                            name: '拒绝原因',
                            type: 'textarea',
                            dataIndex: 'reason',
                            placeholder: '拒绝必填',
                            labelCol: 8,
                            wrapperCol: 16,
                            message: '请填写拒绝原因'
                        },
                    ],
                })
            }
        })
    }



    onSubmit = () => {
        this.props.refreshList();
        this.setState({
            visible: false
        })
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
    }

    render() {

        return (
            <>
                <Button style={{marginTop:10}} size={'small'} type={'primary'} onClick={() => {
                    this.setState({visible: true})
                }}>新增第三方系统账户并绑定本系统账户</Button>
                <Modal
                    // width={window.innerWidth * 0.8}
                    title="新增第三方系统账户并绑定本系统账户"
                    visible={this.props.visible}
                    footer={null}
                    destroyOnClose={true}
                    onCancel={this.props.handleCancel}
                >
                    <Form
                        content={this.state.content} onSubmit={this.onSubmit} url={'/api/user/addAndBind'}
                        values={Object.assign(this.props.item.user,{'dept_id':this.props.item.dept_id})}
                        value={{id:this.props.item.id}}
                    />
                </Modal>
            </>
        );
    }
}
